var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucesstheme3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.014 5.77308C18.5979 3.15006 22.4021 3.15006 23.986 5.77308C24.9081 7.30014 26.7167 8.04929 28.4485 7.62152C31.4233 6.88674 34.1133 9.57675 33.3785 12.5515C32.9507 14.2833 33.6999 16.0919 35.2269 17.014C37.8499 18.5979 37.8499 22.4021 35.2269 23.986C33.6999 24.9081 32.9507 26.7167 33.3785 28.4485C34.1133 31.4233 31.4233 34.1133 28.4485 33.3785C26.7167 32.9507 24.9081 33.6999 23.986 35.2269C22.4021 37.8499 18.5979 37.8499 17.014 35.2269C16.0919 33.6999 14.2833 32.9507 12.5515 33.3785C9.57675 34.1133 6.88674 31.4233 7.62152 28.4485C8.04929 26.7167 7.30014 24.9081 5.77308 23.986C3.15006 22.4021 3.15007 18.5979 5.77308 17.014C7.30014 16.0919 8.04929 14.2833 7.62152 12.5515C6.88674 9.57675 9.57675 6.88674 12.5515 7.62152C14.2833 8.04929 16.0919 7.30014 17.014 5.77308Z",
    fill: "#22C178"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7547 16.6321L17.8316 23.5943L15.4717 21.2211",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucesstheme3);
export default __webpack_public_path__ + "static/media/sucesstheme3.a52395495a7449b17c7ff8ced95abf0d.svg";
export { ForwardRef as ReactComponent };